/**
 * Wait Node Component — Sprint 17 enhanced with Lucide + CSS vars
 */
import { useTranslation } from "@/i18n";
import { cn } from "@/lib/utils";
import { Clock } from "lucide-react";
import type { WaitNodeData } from "./types";

interface WaitNodeProps {
  node: WaitNodeData;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export function WaitNode({ node, isSelected, onSelect }: WaitNodeProps) {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() => onSelect(node.id)}
      className={cn(
        "flex items-center gap-2 rounded-lg border-2 px-4 py-3 text-left shadow-sm transition-colors",
        "bg-[var(--color-warning)]/5 border-[var(--color-warning)]/20 hover:border-[var(--color-warning)]/50",
        isSelected && "ring-2 ring-[var(--color-warning)] border-[var(--color-warning)]/80",
      )}
    >
      <Clock className="h-5 w-5 text-[var(--color-warning)]" />
      <div>
        <div className="text-xs font-medium text-[var(--color-warning)] uppercase">
          {t("journey.node.wait")}
        </div>
        <div className="text-sm font-medium text-[var(--color-foreground)]">
          {node.duration} {t(`journey.wait.${node.unit}`)}
        </div>
      </div>
    </button>
  );
}
